import { hasInjectionContext, inject } from "vue-demi";
import { abProvideKey } from "../constants.mjs";
export default function useTheme() {
  if (!hasInjectionContext()) {
    console.error(
      "useTheme can only be used inside setup() function or functions that support injection context"
    );
    return;
  }
  const theme = inject(abProvideKey);
  if (!theme) {
    console.error(
      "No theme found in Vue context, use 'AsbisUIPlugin' to properly initialize the library."
    );
    return;
  }
  return theme;
}
